import Medusa from "@medusajs/medusa-js";

let MEDUSA_BACKEND_URL = "https://admin.parfimerija-duro.rs";

if (process.env.REACT_APP_MEDUSA_BACKEND_URL) {
  MEDUSA_BACKEND_URL = process.env.REACT_APP_MEDUSA_BACKEND_URL;
} else if (process.env.NEXT_PUBLIC_MEDUSA_BACKEND_URL) {
  // Backwards compatibility for existing deployments.
  MEDUSA_BACKEND_URL = process.env.NEXT_PUBLIC_MEDUSA_BACKEND_URL;
}

export const medusaClient = new Medusa({
  baseUrl: MEDUSA_BACKEND_URL,
  maxRetries: 3,
});

export { MEDUSA_BACKEND_URL };
